import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PurchaseOrderOutline } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0574. 以前のプロジェクト候補プロジェクト（費用）一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/target_prev_purchase_orders
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};
const targetPrevPurchaseOrders = (props: Props): Promise<PurchaseOrderOutline[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.id}/target_prev_purchase_orders`
  );
};

export const useTargetPrevPurchaseOrders = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => targetPrevPurchaseOrders(props),
  });
};

export const useInvalidateTargetPrevPurchaseOrders = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) }).then((r) => {});
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return [
    'workspaces',
    props.identifier,
    'teams',
    props.team_id,
    'purchase_orders',
    props.id,
    'target_prev_purchase_orders',
  ];
};
